/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");


require('components/common/table-data/table-data');
require('components/common/date-time/date-time')
require('components/common/drop-menu-input/drop-menu-input')
require('components/base/tab/tab')
require('components/base/icon/icon')
require('components/base/input-box/input-box');
require('components/base/btn/btn');
require('components/base/loading/loading');

const tip = require('components/base/pop/tip');
const confirm = require('components/base/pop/confirm');
const ajaxHttp = require('appUtil/ajaxHttp.js')

const { tab: tabEvent, inputBox: inputBoxEvent } = require('components/config/event.json');
const { apiPath } = require('appService/api');

require('./challenge-list.scss');
const template = require('./challenge-list.tpl');

const challengeList = {
  name: "ad-config-list",
  template,
  data() {
    return {
      thItems: ["编号", "昵称", "微信头像", "海报", "上传时间",  "打星标"],
      url: apiPath.challenge.getAdminList,
      queryArgs: {
				status: "",
        nickname: ""
      },
      statusList: [
        { 'value': -1, 'text': '选择海报类型'},
        { 'value': 0, 'text': '一般图片'},
        { 'value': 1, 'text': '打星图片'},
        { 'value': 2, 'text': '官方图片'}
      ],
      challengeChangeStatus: apiPath.challenge.challengeChangeStatus,
      isLoad: false
    }
  },
  watch: {
    
  },
  events: {
    
  },

  filters: {

  },

  methods: {
    fetchQuery({queryValue}) {
      queryValue._index = 1;
      if (queryValue.status == -1) queryValue.status = "";
      console.log(queryValue)
      this.$refs.tableData.query(queryValue).fetch();
    },
    xingSelectFun(item) {   //选择打星  点击普通图片 变为打星标图片， 反之亦然
      let { status } = item;
      if (this.isLoad) return;
      this.isLoad = true;

      item.status = status == 0 ? 1 : (status == 2 ? 1 : 0);
      this.changeStatus(item);
    },
    guanSelectFun(item) {   //选择官方   点击图片图片 变为官方图片， 反之亦然
      let { status } = item;
      if (this.isLoad) return;
      this.isLoad = true;

      item.status = status == 2 ? 0 : 2;
      this.changeStatus(item);
    },
    changeStatus(item) {
      let data = {
        id: item.id,
        status: +item.status
      }
      ajaxHttp(this.challengeChangeStatus, {
        "type": "POST",
        "data": data
      }).then((res) => {
        this.isLoad = false;
        if(res.code == 0){
          tip(item.status == 0 ? "取消成功" : "标注成功");
        }
      }).catch((res) => {
        this.isLoad = false;
        tip(res.message);
      });
    }
  }
}

module.exports = challengeList;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/challenge/challenge-list/challenge-list.js